import { SET_PRINTERS_LIST, SET_PRINTERS_LIST_LOADING, GET_PRINTER_TAGS_LIST } from 'redux/actions/types';
const initialState = {
  list: [],
  loading: false,
  printerTagsList: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PRINTERS_LIST:
      return {
        ...state,
        list: payload.data,
      };
    case GET_PRINTER_TAGS_LIST:
      return {
        ...state,
        printerTagsList: payload
      }
    case SET_PRINTERS_LIST_LOADING:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};
